import { render, staticRenderFns } from "./IotDevicePoweredByAssetL1.vue?vue&type=template&id=9837cdb8&"
import script from "./IotDevicePoweredByAssetL1.vue?vue&type=script&lang=js&"
export * from "./IotDevicePoweredByAssetL1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports